const weather = [
  { kanji: "霧", yomi: "きり" },
  { kanji: "霰", yomi: "あられ" },
  { kanji: "霙", yomi: "みぞれ" },
  { kanji: "霞", yomi: "かすみ" },
  { kanji: "露", yomi: "つゆ" },
  { kanji: "雹", yomi: "ひょう" },
  { kanji: "雫", yomi: "しずく" },
  { kanji: "靄", yomi: "もや" },
  { kanji: "霜", yomi: "しも" },
  { kanji: "暁", yomi: "あかつき" },
  { kanji: "黄昏", yomi: "たそがれ" },
  { kanji: "稲妻", yomi: "いなずま" },
  { kanji: "雷", yomi: "かみなり" },
  { kanji: "霹靂", yomi: "へきれき" },
  { kanji: "雲霞", yomi: "うんか" },
  { kanji: "五月雨", yomi: "さみだれ" },
  { kanji: "飃", yomi: "つむじかぜ" },
  { kanji: "凩", yomi: "こがらし" },
  { kanji: "旱", yomi: "ひでり" },
  { kanji: "颪", yomi: "おろし" },
  { kanji: "陽炎", yomi: "かげろう" },
  { kanji: "漣", yomi: "さざなみ" },
  { kanji: "凪", yomi: "なぎ" },
  { kanji: "薫風", yomi: "くんぷう" },
  { kanji: "朧月", yomi: "おぼろづき" },
  { kanji: "秋霖", yomi: "しゅうりん" },
  { kanji: "氷雨", yomi: "ひさめ" },
  { kanji: "時雨", yomi: "しぐれ" },
  { kanji: "時化", yomi: "しけ" },
  { kanji: "秋雨", yomi: "しゅうう" },
  { kanji: "東雲", yomi: "しののめ" },
  { kanji: "蜃気楼", yomi: "しんきろう" },
  { kanji: "樹氷", yomi: "じゅひょう" },
  { kanji: "氷柱", yomi: "つらら" },
  { kanji: "十六夜", yomi: "いざよい" },
];

export { weather };
